export default {"src":"/_next/static/media/arrow-top-black.3a7c233d.svg","height":15,"width":11,"blurWidth":0,"blurHeight":0};